import { REDUX } from 'constants/'
import {
    SectorReducerTypeInitiator,
    SectorAction,
    SectorReducer,
    Sector
} from 'types/sector'
import { ROUTES_NAMES } from 'constants/name.routes'

/**
 * Reducer para objeto sector
 * @param state
 * @param action
 */
const SectorReducers = (
    state = SectorReducerTypeInitiator,
    action: SectorAction
): SectorReducer => {
    switch (action.type) {
        case REDUX.reducers.GET_ALL_SECTORS:
            return {
                ...state,
                sectorsList: action.payload,
                sectorsListNames: action.payload?.map(
                    (sector: Sector) => sector['u_name' as keyof typeof sector]
                ),
                sectorsListDataTable: action.payload.map(
                    (sector: Sector): [string, string, string, string] => [
                        `${ROUTES_NAMES.configurationsRoutes.editSectors}/${sector.sys_id}`,
                        sector.u_name,
                        sector.u_count_inactive,
                        sector.u_count_active
                    ]
                ),
                error: false,
                loading: false
            } as SectorReducer
        case REDUX.reducers.GET_ALL_SECTORS_GROUPED_BY_LOCATION:
            return {
                ...state,
                sectorsGroupedByLocationId: action.payload,
                error: false,
                loading: false
            }
        case REDUX.reducers.MESSAGE_SECTOR:
            return {
                ...state,
                message: action.payload,
                error: false,
                loading: false
            } as SectorReducer
        case REDUX.reducers.GET_CURRENT_SECTOR:
            return {
                ...state,
                sector: action.payload,
                error: false,
                loading: false
            } as SectorReducer
        case REDUX.reducers.ADD_NEW_SECTOR:
            return {
                ...state,
                sectorsList: [...state.sectorsList, action.payload],
                error: false,
                loading: false
            } as SectorReducer
        case REDUX.reducers.UPDATE_SECTOR:
            return {
                ...state,
                sectorsList: state.sectorsList.map(sector => 
                    sector.sys_id === action.payload.sys_id ? action.payload : sector
                ),
                error: false,
                loading: false
            } as SectorReducer
        case REDUX.reducers.ERROR_SECTORS:
            return {
                ...state,
                sectorsList: [],
                error: true,
                loading: false,
                loadingCount: false,
                loadingReportCount: false
            } as SectorReducer
        case REDUX.reducers.GET_ALL_SECTORS_COUNT:
            return {
                ...state,
                sectorAllCount: action.payload,
                error: true, //! IS THIS CORRECT?
                loading: false,
                loadingCount: false
            } as SectorReducer
        case REDUX.reducers.GET_ALL_SECTORS_WITH_NOTIFICATION_COUNT:
            return {
                ...state,
                sectorWithNotificationCount: action.payload,
                error: true, // ! IS THIS CORRECT?
                loading: false,
                loadingCount: false,
                loadingReportCount: false
            } as SectorReducer
        case REDUX.reducers.GET_ALL_SECTORS_COUNT_LOADING:
            return {
                ...state,
                loadingCount: true,
                loadingReportCount: true
            }
        case REDUX.reducers.GET_LOADING:
            return {
                ...state,
                loading: true
            }
        default:
            return state
    }
}

export default SectorReducers
